import { Text } from '@mantine/core'
import { modals } from '@mantine/modals'
import type { TFunction } from 'i18next'

import { formatBytes, needsLargeFileConfirm } from './playback'

export const confirmLargeArchive = (file: File, t: TFunction<'documentation'>): Promise<boolean> => {
  if (!needsLargeFileConfirm(file.size)) return Promise.resolve(true)
  return new Promise(resolve => {
    let settled = false
    const finish = (value: boolean) => {
      if (settled) return
      settled = true
      resolve(value)
    }
    modals.openConfirmModal({
      title: t('largeFileTitle'),
      children: <Text size="sm">{t('largeFileBody', { size: formatBytes(file.size) })}</Text>,
      labels: { confirm: t('continue'), cancel: t('cancel') },
      onConfirm: () => finish(true),
      onCancel: () => finish(false),
      onClose: () => finish(false),
    })
  })
}
